import axios from '../../../helpers/custom-axios';
import { confirmation, notify } from '../../../helpers/notifications';

export const createTemplate = async (template) => {
  return axios
    .post(`/manage/templates`, { template })
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const updateTemplate = async (template) => {
  const { id, name } = template;
  return axios
    .put(`/manage/templates/${id}`, {
      template: { name },
    })
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const copyTemplate = async (id, callback) => {
  confirmation.copy(async () =>
    axios
      .get(`/manage/templates/${id}/copy`)
      .then((res) => {
        notify.success('Template Copied');
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      })
  );
};

export const destroyTemplate = async (id, callback) => {
  confirmation.destroy(async () =>
    axios
      .delete(`/manage/templates/${id}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      })
  );
};

export const applyTemplateToUser = async (
  template_id,
  userModel,
  userID,
  allow_overwrite
) => {
  let params = { [userModel + '_id']: userID };
  if (allow_overwrite) params['allow_overwrite'] = true;

  return axios
    .get(`/manage/templates/${template_id}/apply`, {
      params,
    })
    .then((res) => {
      notify.alertSuccess('Permissions Template Applied');
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const generateTemplateFromUser = async (userID, userModel) => {
  let params = { [userModel + '_id']: userID };

  return axios
    .get(`/manage/templates/generate`, { params })
    .then((res) => {
      notify.alertSuccess('Template Generated');
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

// TEMPLATE ROLES
export const createTemplateRole = async (template_role) => {
  return axios
    .post(`/manage/template_roles`, { template_role })
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const updateTemplateRole = async (id, template_role) => {
  return axios
    .put(`/manage/template_roles/${id}`, { template_role })
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const destroyTemplateRole = async (id) => {
  return axios
    .delete(`/manage/template_roles/${id}`)
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};
